import PropTypes from 'prop-types'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/common/components/ui/dialog'
import { Button } from '@/common/components/ui/button'

const formatDate = (isoDate) => {
  try {
    return new Date(isoDate).toLocaleDateString('en-US', {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    })
  } catch {
    return isoDate
  }
}

const CONTENT = {
  cancel: {
    title: 'Cancel Booking',
    confirmationText: 'Are you sure you want to cancel this booking?',
    confirmButtonText: (isLoading) => isLoading ? 'Cancelling...' : 'Cancel Booking',
    cancelButtonText: 'Keep Booking',
  },
  book: {
    title: 'Confirm Booking',
    confirmationText: 'Would you like to book this seat?',
    confirmButtonText: (isLoading) => isLoading ? 'Booking...' : 'Book Seat',
    cancelButtonText: 'Cancel',
  },
}

const BookingConfirmation = ({
  show,
  onCancel,
  onConfirm,
  seatInfo,
  isLoading = false,
  actionType = 'book',
}) => {
  const { seatId, rowId, date, officeName } = seatInfo || {}
  const content = CONTENT[actionType] ?? CONTENT.book

  return (
    <Dialog open={show} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{content.title}</DialogTitle>
        </DialogHeader>

        <div className="bg-[#f8f9fa] rounded-xl p-4">
          <div className="text-base font-semibold text-[#1a1a1a] mb-2">
            Seat {seatId} - Row {rowId}
          </div>
          <div className="text-sm text-[#666] leading-relaxed">
            <div className="mb-1"><strong>Office:</strong> {officeName}</div>
            <div><strong>Date:</strong> {formatDate(date)}</div>
          </div>
        </div>

        <p className="text-sm text-center text-[#333]">{content.confirmationText}</p>

        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={isLoading}>
            {content.cancelButtonText}
          </Button>
          <Button
            className={
              actionType === 'cancel'
                ? 'bg-cancel hover:bg-[#ff3742] text-white'
                : ''
            }
            onClick={onConfirm}
            disabled={isLoading}
          >
            {content.confirmButtonText(isLoading)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

BookingConfirmation.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  seatInfo: PropTypes.shape({
    seatId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    date: PropTypes.string,
    officeName: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
  actionType: PropTypes.oneOf(['book', 'cancel']),
}

export default BookingConfirmation
